import type { Deal } from '../types';
import type { CompletionJob } from '../api/orderJob';

export const jobStatuses = ['Booked', 'Invoiced & dispatched', 'Installed, feedback pending', 'Feedback in', 'Day-7 call', 'Closed'] as const;
export const jobStatusLabels: Record<string, string> = { not_booked: 'Not booked', booked: 'Booked', invoiced_dispatched: 'Invoiced & dispatched', installed_feedback_pending: 'Installed, feedback pending', feedback_in: 'Feedback in', day7_call: 'Day-7 call', closed: 'Closed' };
export function dealJobStatus(deal: Pick<Deal, 'site_phase' | 'installed_at' | 'feedback_submitted_at' | 'feedback_confirmed_at' | 'order_number'> & { job_status?: string; job?: CompletionJob }): string {
  const authoritative = deal.job?.job_status || deal.job_status;
  if (authoritative && jobStatusLabels[authoritative]) return jobStatusLabels[authoritative];
  if (deal.site_phase === 'closed' && deal.feedback_confirmed_at) return 'Closed';
  if (deal.feedback_submitted_at) return 'Feedback in';
  if (deal.installed_at) return 'Installed, feedback pending';
  if (deal.site_phase === 'material_supplied') return 'Invoiced & dispatched';
  return deal.order_number ? 'Booked' : 'Not booked';
}

export function closureRequirements(deal: Pick<Deal, 'installed_at' | 'feedback_submitted_at' | 'feedback_confirmed_at'> & { job?: CompletionJob }): string[] {
  if (deal.job) return [...deal.job.blockers];
  return [!deal.installed_at && 'Installation not recorded', !deal.feedback_submitted_at && 'Customer feedback missing', !deal.feedback_confirmed_at && 'Customer-care confirmation missing'].filter((value): value is string => !!value);
}
